import { decode } from "html-entities";
import CouponCms from "./CouponCms";
import PartnerCarousel from "./PartnerCarousel";
import { CMS_PRIVILEGE_ROUTE_PATH } from "@const/route-paths.const";
import { useRouter } from "next/router";

interface Props {
  cmsDescHtml: any;
}

const CmsDetail = ({ cmsDescHtml }: Props) => {
  const router = useRouter();

  return (
    <>
      {router.asPath === CMS_PRIVILEGE_ROUTE_PATH && (
        <>
          <CouponCms />
          <PartnerCarousel />
        </>
      )}
      <div dangerouslySetInnerHTML={{ __html: decode(cmsDescHtml) }}></div>
    </>
  );
};

export default CmsDetail;
